import { render, staticRenderFns } from "./TeamsportMatchResult.vue?vue&type=template&id=1bf6099b&scoped=true"
import script from "./TeamsportMatchResult.vue?vue&type=script&lang=js"
export * from "./TeamsportMatchResult.vue?vue&type=script&lang=js"
import style0 from "./TeamsportMatchResult.vue?vue&type=style&index=0&id=1bf6099b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6099b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VProgressCircular})
